import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu, X, ShoppingCart } from "lucide-react";
import { BrandLogo } from "./BrandLogo";
import { scrollToId } from "../data/books";

const LINKS = [
  { id: "books", label: "The Books", testid: "nav-link-books" },
  { id: "characters", label: "Meet the Cousins", testid: "nav-link-characters" },
  { id: "author", label: "Author", testid: "nav-link-author" },
  { id: "contact", label: "Contact", testid: "nav-link-contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const go = (id) => {
    setOpen(false);
    if (pathname !== "/") {
      navigate("/");
      setTimeout(() => scrollToId(id), 400);
    } else {
      scrollToId(id);
    }
  };

  return (
    <header
      data-testid="navbar"
      className="fixed top-0 inset-x-0 z-50 border-b-2 border-ink bg-cream/85 backdrop-blur-md"
    >
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <button onClick={() => go("home")} aria-label="Back to top" className="transition-transform duration-200 hover:-rotate-3 hover:scale-105">
          <BrandLogo />
        </button>

        <div className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="font-head text-sm font-bold uppercase tracking-wide text-ink/70 transition-colors duration-200 hover:text-maroon"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="nav-amazon-btn"
            href="https://www.amazon.com/s?k=Corella+Berry-Moten"
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center gap-2 rounded-full border-2 border-ink bg-banana px-5 py-2 font-head text-sm font-extrabold uppercase tracking-wide shadow-pop transition-all duration-200 hover:-translate-y-0.5 hover:shadow-pop-lg active:translate-y-0 active:shadow-pop-sm"
          >
            <ShoppingCart className="h-4 w-4 transition-transform duration-200 group-hover:-rotate-12" />
            Get on Amazon
          </a>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="rounded-lg border-2 border-ink bg-white p-2 shadow-pop-sm lg:hidden"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
        </button>
      </nav>

      {open && (
        <div className="border-t-2 border-ink bg-cream px-4 py-4 lg:hidden" data-testid="nav-mobile-menu">
          <div className="flex flex-col gap-3">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testid}-mobile`}
                onClick={() => go(l.id)}
                className="rounded-lg border-2 border-ink bg-white px-4 py-3 text-left font-head text-sm font-bold uppercase tracking-wide shadow-pop-sm"
              >
                {l.label}
              </button>
            ))}
            <a
              data-testid="nav-amazon-btn-mobile"
              href="https://www.amazon.com/s?k=Corella+Berry-Moten"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 rounded-lg border-2 border-ink bg-banana px-4 py-3 font-head text-sm font-extrabold uppercase shadow-pop-sm"
            >
              <ShoppingCart className="h-4 w-4" /> Get on Amazon
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
